module.exports = __webpack_public_path__ + "static/media/__New.d0370ecb.svg";